export default __webpack_public_path__ + "static/media/28.90ac4912.png";